import type React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export type SeeAllLinkProps = {
  to: string;
  children: React.ReactNode;
};

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  font-family: ${({ theme }) => theme.typography.poppins};
  font-size: ${({ theme }) => theme.typography.small};
  font-weight: 400;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &::after {
    content: '>';
    font-size: 1rem;
  }
`;

const SeeAllLink: React.FC<SeeAllLinkProps> = ({ to, children }) => <StyledLink to={to}>{children}</StyledLink>;

export default SeeAllLink;
